class SiteHeader {
	constructor(el) {
		this.el = el;
		this.headerHeight = 0;

		this.updateHeaderHeightVar();
		this.setupEventHandlers();
		SiteHeader.handleMenuSpacerLinks();
	}

	setupEventHandlers() {
		// desktop nav hover handlers
		const desktopNavLinkEls = this.el.querySelectorAll('.site-header__desktop-menu-container');

		// add/remove the 'desktop-menu-open' class to an <html> element when the
		// mouse enters/leaves a desktop menu link element
		Array.from(desktopNavLinkEls).forEach((linkEl) => {
			linkEl.addEventListener('mouseenter', () => {
				document.documentElement.classList.add('desktop-menu-open');
			});

			linkEl.addEventListener('mouseleave', () => {
				document.documentElement.classList.remove('desktop-menu-open');
			});
		});

		// mobile menu button handler
		const btnMobileMenu = this.el.querySelector('.site-header__mobile-menu-button');

		if (btnMobileMenu) {
			btnMobileMenu.addEventListener('click', () => {
				if (document.documentElement.classList.contains('mobile-menu-active')) {
					btnMobileMenu.setAttribute('aria-label', 'Open Menu');
					btnMobileMenu.setAttribute('aria-expanded', 'false');
				} else {
					btnMobileMenu.setAttribute('aria-label', 'Close Menu');
					btnMobileMenu.setAttribute('aria-expanded', 'true');
				}
				document.documentElement.classList.toggle('mobile-menu-active');
			});
		}

		// $('.site-header__mobile-menu-button').on('click tap', function () {
		// 	$('html').toggleClass('mobile-menu-active');
		// });

		// update header height on resize
		window.addEventListener('resize', () => this.updateHeaderHeightVar());

		// $(window).resize(() => {
		// 	this.updateHeaderHeightVar();
		// });

		// update header height on scroll
		window.addEventListener('scroll', () => this.updateHeaderHeightVar());

		// $(window).scroll(() => {
		// 	this.updateHeaderHeightVar();
		// });
	}

	updateHeaderHeightVar() {
		// this.headerHeight = this.$el.outerHeight();
		this.headerHeight = this.el.offsetHeight;
	}

	static handleMenuSpacerLinks() {
		const mobileInner = document.querySelector('.menu-dropdown__mobile-inner');

		if (mobileInner) {
			const spacerLinks = document.querySelectorAll('.menu-dropdown__primary-link-large.is-spacer');

			spacerLinks.forEach((anchor) => {
				const section = anchor.closest('.menu-dropdown__section');

				if (section) {
					const anchorsInSection = section.querySelectorAll('a');

					if (anchorsInSection.length === 1 && anchorsInSection[0] === anchor) {
						section.classList.add('is-spacer');
					}
				}
			});
		}
	}
}

export default SiteHeader;
